// extracted by mini-css-extract-plugin
export var text = "_4l-0";